// @flow

import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const DEBUG = false;

type ImageMapProps = {
	areasSelector: string,
	hoverAreaSelector: string,
	baseHoverImageSrc: string,
	lastOpenedImageSrc: string | null,
	changeEvent: string,
	mapBaseWidth: number,
	mapItems: string,
};

/**
 * Komponenta pro praci s image mapou
 */
class ImageMap extends WebComponent {

	defaultProps: ImageMapProps;
	props: ImageMapProps;
	objects: Object;
	element: HTMLElement;
	wasOpened: boolean;

	static defaultProps = {
		areasSelector:      'map area',
		hoverAreaSelector:  '.image-map__hover',
		baseHoverImageSrc:  'data:image/svg+xml,%3Csvg%20xmlns=\'http://www.w3.org/2000/svg\'%20viewBox=\'0%200%201%201\'%3E%3C/svg%3E',
		lastOpenedImageSrc: null,
		changeEvent:        'imageMapChange',
		wasOpened:          false,
	};

	constructor(props: ?ImageMapProps) {
		super(props);

		this.mouseEnterHandler = this.mouseEnterHandler.bind(this);
		this.mouseLeaveHandler = this.mouseLeaveHandler.bind(this);
		this.clickHandler = this.clickHandler.bind(this);
		this.deselectArea = this.deselectArea.bind(this);
		this.resizeHandler = this.resizeHandler.bind(this);
		this.getData = this.getData.bind(this);

		this.wasOpened = false;

		clog(this);
	}

	didMount() {
		clog('did mount');
		this.objects = this.mapObjects();
		// this.data = this.mapObjects();
		this.bindListeners();
	}

	willUnMount() {
		if ( this.objects.areas ) {
			this.objects.areas.forEach((area) => {
				area.removeEventListener('mouseenter', this.mouseEnterHandler);
				area.removeEventListener('mouseleave', this.mouseLeaveHandler);
				area.removeEventListener('click', this.clickHandler);
				area.removeEventListener('touch', this.clickHandler);
			});
		}
		document.removeEventListener('cardClosed', this.deselectArea);
		window.removeEventListener('resizeEnd', this.resizeHandler);
		this.objects = {};
	}

	bindListeners() {
		clog('binding');
		// clog(this.objects.areas);
		if ( this.objects.areas ) {
			this.objects.areas.forEach((area) => {
				area.addEventListener('mouseenter', this.mouseEnterHandler);
				area.addEventListener('mouseleave', this.mouseLeaveHandler);
				area.addEventListener('click', this.clickHandler);
				area.addEventListener('touch', this.clickHandler);

				// store original coords
				area.dataset.coords = area.getAttribute('coords');
			});

		}

		document.addEventListener('cardClosed', this.deselectArea);

		window.addEventListener('resizeEnd', this.resizeHandler);
		window.addEventListener('load', this.resizeHandler);
		window.addEventListener('partialUpdateComplete', this.resizeHandler);

		window.addEventListener('load', this.getData);
	}

	mapObjects() {
		clog('mapping objects');
		const objects = {};
		objects.areas = [ ...this.element.querySelectorAll(this.props.areasSelector) ];
		objects.hoverImg = this.element.querySelector(this.props.hoverAreaSelector);
		return objects;
	}

	mouseEnterHandler(event: ?SyntheticEvent<MouseEvent | TouchEvent>) {
		// clog('mouse entered');
		const hoveredArea = event.target;
		if ( hoveredArea instanceof HTMLAreaElement ) {
			this.objects.hoverImg.src = `/img/map/${ hoveredArea.getAttribute('alt') }.png`;
		}
	}

	mouseLeaveHandler(event: ?SyntheticEvent<MouseEvent>) {
		// clog('mouse left');
		if ( this.wasOpened ) {
			this.objects.hoverImg.src = this.props.lastOpenedImageSrc;
		} else {
			this.objects.hoverImg.src = this.props.baseHoverImageSrc;
		}
	}

	clickHandler(event: ?SyntheticEvent<MouseEvent | TouchEvent>) {
		clog('area clicked');
		const clickedArea = event.target;
		const publicEvent = new CustomEvent(
			this.props.changeEvent,
			{
				bubbles:    true,
				cancelable: false,
				detail:     clickedArea,
			},
		);

		if ( clickedArea instanceof HTMLAreaElement ) {
			this.wasOpened = true;
			const src = `/img/map/${ clickedArea.getAttribute('alt') }.png`;
			this.props.lastOpenedImageSrc = src;
			this.objects.hoverImg.src = src;
		}

		document.dispatchEvent(publicEvent);
	}

	deselectArea() {
		clog('closing areas');
		this.wasOpened = false;
		this.props.lastOpenedImageSrc = null;
		this.objects.hoverImg.src = this.props.baseHoverImageSrc;
	}

	resizeHandler(event: ?SyntheticEvent<UIEvent | Event>) {
		clog('window resized');
		const baseWidth = this.props.mapBaseWidth;
		const actualWidth = this.element.clientWidth;
		if ( actualWidth < baseWidth ) {
			const ratio = actualWidth / baseWidth;
			clog(ratio);
			this.objects.areas.forEach((area) => {
				const prevCoords = area.dataset.coords.split(',');
				const newCoords = prevCoords.map(coord => coord * ratio);
				area.setAttribute('coords', newCoords.join(','));
			});
		} else {
			clog('map resize not necessary');
			this.objects.areas.forEach((area) => {
				area.setAttribute('coords', area.dataset.coords);
			});
		}
	}

	async getData() {
		const self = this;
		const { mapItems } = self.props;

		const handleJsonData = (jsonString) => {
			if ( jsonString.data.length ) {
				self.objects.areas.forEach((area) => {
					const areaId = area.getAttribute('alt');
					const manager = jsonString.data.filter(item => item.region === areaId);
					let managerString = '';
					if ( manager.length === 1 ) {
						managerString = JSON.stringify(manager[ 0 ]);
					}
					area.setAttribute('data-manager', managerString);
				});
			}
		};

		if ( window.fetch ) {
			await fetch(mapItems)
				.then(response => response.json())
				.then(jsonString => handleJsonData(jsonString));
		} else {
			// IE sucks!
			const xhr = new XMLHttpRequest();
			xhr.addEventListener('load', () => handleJsonData(JSON.parse(xhr.responseText)));
			xhr.open('GET', mapItems);
			xhr.send();
		}
	}
}

export default ImageMap;

// simple logger
function clog(...args: any): void {
	if ( window.console && DEBUG ) {
		/* eslint-disable no-alert, no-console */
		console.group('Debug of ImageMap');
		Object.values(args).forEach(value => console.log(value));
		console.groupEnd();
		/* eslint-enable no-alert, no-console */
	}
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ImageMap.js